// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodAllergenId = (z.number());
export const foodAllergen = z.object({
    id: foodAllergenId,
    name: z.string(),
    deleted_at: z.date().nullable(),
    created_at: z.date(),
    deleted_by: operatorId.nullable(),
});
export const foodAllergenInitializer = z.object({
    id: foodAllergenId.optional(),
    name: z.string(),
    deleted_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    deleted_by: operatorId.optional().nullable(),
});
export const foodAllergenMutator = z.object({
    id: foodAllergenId.optional(),
    name: z.string().optional(),
    deleted_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodAllergen.js.map